import { motion } from 'framer-motion';

export const skills = {
  fullstack: ['React', 'MongoDB/Supabase', 'TailwindCSS', 'Typescript', 'Node.js', 'Three.js', 'Socket.io', 'Bun', 'FastAPI'],
  'ai-ml': ['Python', 'PyTorch', 'RAG AI', 'Reinforcement Learning (DQN, GNN)', 'Supervised Learning'],
  robotics: ['C/C++', 'ROS2', 'Docker', 'MPC/PID Controllers', 'Kalman Filters', 'Variational Inference (S-GVI)', 'UART/I2C/CAN/Ethernet/PWM', 'Gazebo'],
};

export const links = [
  { label: 'github', url: 'https://github.com/v2pir' },
  { label: 'linkedin', url: 'https://www.linkedin.com/in/vansh-chhabra-a72260278/' },
  { label: 'twitter', url: 'https://x.com/vanshchhabra343' },
  { label: 'email', url: 'mailto:vchhabr1@uci.edu' },
];

export const experience = [
  {
    role: 'ai engineer intern',
    org: 'repay',
    meta: 'autonomous agents · aws lambda',
    date: 'summer 2026',
    detail: 'shipped 2 autonomous agents to production — cybersecurity workflow automation on aws lambda, with an orchestration layer for concurrent runs.',
  },
  {
    role: 'cto',
    org: 'capy',
    meta: 'company brain · backed by founders inc',
    date: '2025 – 2026',
    detail: 'built a "company brain" that unifies a team\'s tools with permission-aware rag — $3k MRR in 3 weeks.',
  },
];

export default function About() {
  return (
    <div>
      {/* cat .profile */}
      <div className="prompt">
        <span className="p-user">vansh</span>
        <span className="p-sep">@</span>
        <span className="p-user">portfolio</span>
        <span className="p-sep">:</span>
        <span className="p-path">~</span>
        <span className="p-char">$</span>
        <span className="p-cmd">cat .profile</span>
      </div>

      <div className="output">
        <div className="kv-line"><span className="kv-key">name</span>vansh chhabra</div>
        <div className="kv-line"><span className="kv-key">role</span>robotics engineer · fullstack developer</div>
        <div className="kv-line"><span className="kv-key">school</span>uci</div>

        <div className="term-text">
          <p>hi, i'm vansh — i build things in robotics and fullstack. focused on SLAM, control systems, and pcb design. i also make and ship web apps.</p>
          <p>outside of coding, probably listening to music, playing basketball, or hanging with friends.</p>
        </div>
      </div>

      {/* cat .experience */}
      <div className="prompt">
        <span className="p-user">vansh</span>
        <span className="p-sep">@</span>
        <span className="p-user">portfolio</span>
        <span className="p-sep">:</span>
        <span className="p-path">~</span>
        <span className="p-char">$</span>
        <span className="p-cmd">cat .experience</span>
      </div>

      <div className="output">
        {experience.map((job, i) => (
          <motion.div
            key={job.org}
            className="exp-block"
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.06, duration: 0.25 }}
          >
            <div className="exp-head">
              <span className="exp-role">{job.role}</span>
              <span className="exp-at"> @ </span>
              <span className="exp-org">{job.org}</span>
              <span className="exp-date">{job.date}</span>
            </div>
            <div className="exp-meta">{job.meta}</div>
            <div className="exp-detail">{job.detail}</div>
          </motion.div>
        ))}
      </div>

      {/* ls skills/ */}
      <div className="prompt">
        <span className="p-user">vansh</span>
        <span className="p-sep">@</span>
        <span className="p-user">portfolio</span>
        <span className="p-sep">:</span>
        <span className="p-path">~</span>
        <span className="p-char">$</span>
        <span className="p-cmd">ls skills/</span>
      </div>

      <div className="output">
        {Object.entries(skills).map(([category, items], i) => (
          <motion.div
            key={category}
            className="dir-block"
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.06, duration: 0.25 }}
          >
            <div className="dir-label">{category}/</div>
            <div className="skill-list">{items.join('  ')}</div>
          </motion.div>
        ))}
      </div>

      {/* cat .links */}
      <div className="prompt">
        <span className="p-user">vansh</span>
        <span className="p-sep">@</span>
        <span className="p-user">portfolio</span>
        <span className="p-sep">:</span>
        <span className="p-path">~</span>
        <span className="p-char">$</span>
        <span className="p-cmd">cat .links</span>
      </div>

      <div className="output">
        {links.map((link) => (
          <div key={link.label} className="link-row">
            <span className="link-label">{link.label}</span>
            <a href={link.url} target="_blank" rel="noopener noreferrer">
              {link.url.replace('mailto:', '')}
            </a>
          </div>
        ))}
      </div>

    </div>
  );
}
